import clsx from 'clsx';
import Select from 'react-select';

export interface IOption {
  label: string;
  value: string | number;
  selectId: number;
}

export interface ISelectData {
  name?: string;
  placeholder?: string;
  clearable?: boolean;
  searchable?: boolean;
  list: IOption[];
  value?: string;
  onChange?: (value: number | string) => void;
}

interface IFluidSelectProps {
  className?: string;
  name?: string;
  data: ISelectData[];
  onSelect: (selectedOptions: IOption[]) => void;
}

export const FluidSelect = (props: IFluidSelectProps) => {
  return (
    <div className={clsx(props.className)}>
      <div className='flex justify-between gap-4'>
        {props.data.map((select, idx) => (
          <Select
            key={idx}
            className={clsx(idx === 0 && 'w-[120px]', idx === 1 && 'w-[70px]')}
            classNamePrefix='Select'
            name={select.name || `select${idx}`}
            placeholder={select.placeholder || ''}
            isClearable={select.clearable}
            isSearchable={select.searchable}
            options={select.list}
            value={select.list.find((option) => option.value === select.value) || null}
            onChange={(option) => select.onChange?.(option!.value)}
          />
        ))}
      </div>
    </div>
  );
};
